// Addresses Document TABLE rows (getDocument email messages, printer config).
// NOT the same thing as tms-lib's PipelineDocumentTypes, which addresses the
// render pipeline's registry — see the comment there for the distinction.
export enum ReportNames {
  addressLabel = 'Address Label',
  commercialInvoice = 'Commercial Invoice',
  creditNote = 'Credit Note',
  customerStockLabel = 'Customer Stock Label',
  paymentInvoice = 'Payment Invoice',
  despatchNote = 'Despatch Note',
  goodsDeliveryNote = 'Goods Delivery Note',
  locationLabel = 'Location Label',
  pickingList = 'Picking List',
  proformaInvoice = 'Proforma Invoice',
  purchaseContract = 'Purchase Contract',
  purchaseDespatch = 'Purchase Despatch',
  purchaseInvoice = 'Purchase Invoice',
  // The name the user's printer for the Product Label is looked up by - must match the
  // Document row's Description.
  productLabel = 'Product Label',
  purchaseOrder = 'Purchase Order',
  purchasePickingList = 'Purchase Picking List',
  releaseOrder = 'Release Order',
  relocateStock = 'Relocate Stock',
  salesBackOrder = 'Sales Back Order',
  salesContract = 'Sales Contract',
  salesDespatchNote = 'Sales Despatch Note',
  salesInvoice = 'Sales Invoice',
  salesManifest = 'Sales Manifest',
  salesOrderBalances = 'Sales Order Balances',
  salesOrderCollection = 'Sales Order Collection',
  salesOrderConfirmation = 'Sales Order Confirmation',
  salesPack = 'Sales Pack',
  salesQuotation = 'Sales Quotation',
  sampleLabel = 'Sample Label',
  stockLabel = 'Stock Label',
  supplierPickingList = 'Supplier Picking List',
  supplierStockLabel = 'Supplier Stock Label',
}
